import { styled } from "@mui/system";
import { useTheme, Typography } from "@mui/material";

export const ShopNotFoundTypography = styled(Typography)(() => ({
    color: "#393939",
    fontWeight: 700,
    fontFamily: `${useTheme().custom.styles.primaryDescription}`,
    fontSize: "16px",
}));